<script setup lang="ts">
  import { computed, inject } from 'vue';

  import { FileDropzoneKey } from '@/components/file-upload-dropzone';
  import type { FileDropzoneProviderContext } from '@/components/file-upload-dropzone';

  type Size = 'sm' | 'default';

  const props = withDefaults(defineProps<{ size?: Size }>(), {
    size: 'default',
  });

  const context = inject<FileDropzoneProviderContext>(FileDropzoneKey)!;

  const classes = computed(() =>
    props.size === 'sm'
      ? {
          outer: 'p-1.5',
          inner: 'border-4 space-y-1',
          icon: 'text-3xl',
          title: 'text-xs',
        }
      : {
          outer: 'p-2.5',
          inner: 'border-8 space-y-2.5',
          icon: 'text-[55px]',
          title: 'text-xl',
        },
  );
</script>

<template>
  <template v-if="$slots.default">
    <div v-if="context.isOverDropZone.value" class="absolute inset-0 w-full h-full z-50">
      <slot
        v-bind="{
          openFileInput: context.openFileInput,
          fileAttachments: context.fileAttachments.value,
          isOverDropZone: context.isOverDropZone.value,
          isSingleUploadLimitReached: context.isSingleUploadLimitReached.value,
        }"
      />
    </div>
  </template>

  <template v-else>
    <div
      v-if="context.isOverDropZone.value && !context.isSingleUploadLimitReached.value"
      class="flex bg-accent absolute inset-0 w-full h-full z-50 m-0!"
      :class="classes.outer"
    >
      <div
        class="flex flex-col text-center w-full items-center h-fit-content justify-center border-dashed rounded"
        :class="classes.inner"
      >
        <i class="fa-regular fa-cloud-arrow-up text-muted-foreground" :class="classes.icon"></i>

        <strong :class="classes.title">Drop files here to upload</strong>
      </div>
    </div>
  </template>
</template>

<style scoped></style>
